<template>
  <section class="blue dots">
    <div class="container is-grid">
      <div class="is-col-12-md">
        <div class="callout-hero">
          <h3>Where’s my cape?</h3>
          <div>
            <button @click="$router.push({ name: 'SignUp' }).catch(() => {})">
              I’m ready to become<br class="show-br-mobile"/> a Sun Hero <i class="fas fa-caret-right"></i>
            </button>
            <p class="footnote">Verified US healthcare professionals only.</p>
          </div>
          <div class="superhero-gif">
            <img src="@/assets/images/global/super-hero-4.gif" alt=""/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";

section {
  overflow: visible;
  height: 13.5rem;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    height: 28rem;
  }
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 132px;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    flex-flow: column;
    justify-content: center;
    height: 280px;
    padding-top: 3rem;
  }
}

.callout-hero {
  display: flex;
  padding-top: 7rem;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    padding-top: 0;
    flex-direction: column;
  }

  h3 {
    margin-top: 1.5rem;
    font-weight: 700;
    margin-right: 4rem;
    // font-size: .clampedW(4.9, @md-bp, @large-bp) [ @result];
    font-size: 22px;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      text-align: center;
      margin-right: 0;
      margin-top: 0;
      margin-bottom: 2rem;
      // font-size: .clampedW(6, @md-bp, @large-bp) [ @result];
    }
  }

  button {
    width: 37.5rem;
    height: 4.5rem;
    background-color: @color-orange;
    border: none;
    font-family: @open-sans-font;
    font-size: 19px;
    font-weight: 700;
    text-transform: uppercase;
    color: @color-txt-blue;
    cursor: pointer;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      width: 30.5rem;
      height: 9.9rem;
      font-size: 21px;
      text-align: left;
      padding-left: 2rem;
    }
  }

  .footnote {
    margin-top: 1.5rem;
    text-align: center;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      position: relative;
      top: 41px;
      text-align: left;
      font-size: 1.2rem;
    }
  }
}

.superhero-gif {
  position: relative;
  top: -58px;
  width: 13rem;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    left: 58%;
    top: 13.8rem;
    position: absolute;
  }

  img {
    width: 13rem;
  }
}

.dots {
  background-image: url("~@/assets/images/global/callout-dots-left.png");
  background-size: auto 100%;
  background-position: left center;
  background-repeat: no-repeat;
  position: relative;

  & > div {
    z-index: 12;
  }

  &:before {
    background-image: url("~@/assets/images/global/callout-dots-right.png");
    background-size: auto 100%;
    background-position: right center;
    background-repeat: no-repeat;
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  @media screen and (max-width: ~"@{mq-md-bp}em") {
    background-size: 70% auto;
    background-position: bottom left;
    background-image: none;
    &:before {
      background-size: 70% auto;
      background-position: right top;
      background-image: none;
    }
  }
}
</style>
<script>
export default {
  name: 'SunHeroCallout',
}
</script>
